import { LitElement, PropertyValues, TemplateResult, css, html } from 'lit'
import { customElement, property, state } from 'lit/decorators.js'

import { DirectiveResult } from 'lit-html/directive.js'
import { MarkdownStyle } from './markdown-style.js'
import { ScrollbarStyles } from '@operato/styles'
import { md } from './markdown.js'
import { unsafeHTML } from 'lit/directives/unsafe-html.js'

@customElement('ox-markdown')
export class OxMarkdown extends LitElement {
  static styles = [
    ScrollbarStyles,
    MarkdownStyle,
    css`
      #toc {
        position: absolute;
        max-width: 250px;
        background-color: var(--md-sys-color-surface);
        padding: var(--padding-default);
        right: var(--spacing-large);
        font: bold var(--fontsize-large) var(--theme-font);
        color: var(--md-sys-color-on-secondary-container);
      }
      #toc ul {
        list-style: circle;
        margin: var(--margin-default) 0 0 var(--spacing-large);
        padding: 0;
      }
      #toc a {
        display: inline-block;
        margin-left: -var(--spacing-small);
        padding: var(--spacing-small) 0;
        font: normal var(--fontsize-default) var(--theme-font);
        color: var(--md-sys-color-on-secondary-container);
        text-decoration: none;
        cursor: pointer;
      }
      #toc a:hover {
        background-color: var(--md-sys-color-surface);
        text-decoration: underline;
        color: var(--md-sys-color-on-primary-container);
      }

      @media screen and (max-width: 460px) {
        #toc {
          background-color: var(--md-sys-color-background);
          border-left: 4px solid var(--md-sys-color-on-primary-container);
          border-bottom: 1px dotted rgba(0, 0, 0, 0.2);
          position: relative;
          width: 100%;
          max-width: initial;
          padding: var(--padding-default) var(--padding-default) var(--padding-default) var(--spacing-large);
        }
      }
    `
  ]

  @property({ type: String }) src?: string
  @property({ type: Boolean }) toc: boolean = false

  @state() _html?: TemplateResult | DirectiveResult | null
  @state() _headings: any[] = []

  render() {
    return html` ${this.toc ? this.renderToc() : html``} ${this._html} `
  }

  renderToc() {
    var toc = this._headings || []

    return toc && toc.length > 0
      ? html`
          <div id="toc">
            Table Of Contents
            <ul>
              ${toc.map(
                heading => html` <li><a @click=${() => heading?.scrollIntoView()}>${heading.textContent}</a></li> `
              )}
            </ul>
          </div>
        `
      : html``
  }

  async updated(changed: PropertyValues<this>) {
    if (changed.has('src')) {
      if (this.src) {
        const response = await fetch(this.src)
        const content = await response.text()

        if (!response.ok) {
          this._html = html`
            <h1>Error : ${response.status}</h1>
            <div>${content}</div>
          `
        } else {
          if (response.headers.get('Content-Type')?.indexOf('text/markdown') !== -1) {
            this._html = unsafeHTML(
              (await md(content, {
                baseUrl: this.src,
                linkBaseUrl: document.baseURI
              } as StructuredSerializeOptions)) || ''
            )
          } else {
            this._html = unsafeHTML(content || '')
          }
        }
      }
    }

    if (changed.has('_html')) {
      this._headings = Array.from(this.renderRoot.querySelectorAll('h2'))
    }
  }
}
